import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-slate-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi7qcjipzmc">
          <p className="text-ocean font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-24" data-mp="15pw2kzun6mxd">
            <span className="text-cta" data-id="element-25" data-mp="1jgr4ttamy5rz">5</span> PROFESSIONAL BONUS GUIDES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-26" data-mp="1eq2a853nssom">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-cream border border-cta/20 rounded-2xl p-8 shadow-sm shadow-navy/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="r0ge5qil2tku" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy text-cta px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-28" data-mp="2jk8v8qijkarf">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-white border border-cta/50 rounded-full flex items-center justify-center text-cta mb-4" data-id="element-29" data-mp="1qvbn3g81nuce">
                <Gift size={24} data-id="element-30" data-mp="20rodo58als2x" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-navy" data-id="element-31" data-mp="20q3jigpw4b5l">{bonus.title}</h3>
              <p className="text-ocean text-sm font-semibold mb-4 border-l-4 border-cta pl-4" data-id="element-32" data-mp="25s2kxl22kxzw">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-ink text-sm mb-4 leading-relaxed" data-id="element-33" data-mp="3h4bude1asw1e">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-navy font-semibold text-sm mb-3" data-id="element-34" data-mp="1c4kkepibpoml">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-35" data-mp="1q43dqc6h6veu">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-36" data-mp="tdszqrsvybsw">
                        <CheckCircle2 size={16} className="text-ocean shrink-0 mt-0.5" data-id="element-37" data-mp="tbq4ntcvlshb" />
                        <span className="text-ink text-sm" data-id="element-38" data-mp="176irlcv3iaxx">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-navy font-semibold text-sm mb-3" data-id="element-39" data-mp="anuvynw4f4v2">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-40" data-mp="htnwbjsugwk">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-navy font-semibold text-sm bg-white border border-aqua/30 rounded-lg px-3 py-2" data-id="element-41" data-mp="3mqmjwsdwxml6">
                        {bullet}
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-42" data-mp="o7nysnkk5ve6">
                {bonus.system && <div data-id="element-43" data-mp="9aoimbbn4u83">
                    <p className="text-navy font-semibold text-sm mb-2" data-id="element-44" data-mp="9b6lhqst66oz">{bonus.systemLabel}</p>
                    <p className="text-white font-bold text-xs sm:text-sm tracking-wide bg-navy border-l-4 border-aqua rounded-lg px-3 py-2" data-id="element-45" data-mp="e984kbq8i60g">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-cta/20" data-id="element-46" data-mp="3f982047wdufi">
                    {bonus.closing.map(line => <p key={line} className="text-navy font-semibold text-sm italic" data-id="element-47" data-mp="3afvho6a949sk">
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}